import React from "react";

import classes from "./Info.css";

const Info = () => {
  return (
    <div className={classes.Info}>
      <h2>The PRIME Diet</h2>
      <p>
        This diet is all about insulin. This hormone is a threshold guardian
        standing between you and body transformation.
      </p>
      <p>
        The foundation of the diet is an insulin reset. This is a strategic
        approach to your nutrition that will do exactly what the name implies —
        reset your insulin. Literally. Ultimately, the goal is to increase your
        insulin sensitivity, which is the first step to making your body better
        at building muscle and losing fat.
      </p>
      <h3>MEAL TIMING AND STRUCTURE</h3>
      <h4>Fasting</h4>
      <p>
        During Prime, you’ll be using what you’ll call the 16/8. Now I’d love to
        tell you that the 16/8 is a delicious sub sandwich with eight meats and
        sixteen toppings, but in fact it just means that you will fast for
        sixteen out of every twenty-four hours, with the remaining eight hours
        being your feeding window.
      </p>
      <p>
        While in some sense it won’t make a huge difference how you structure
        that breakdown, I recommend setting your feeding window to begin
        anywhere between noon (ending at eight p.m.) and five p.m. (ending at
        one a.m.), depending on when you wake up and go to bed. Put another way,
        you should look to have your first meal about six to eight hours after
        you wake up, but this isn’t a hard rule.
      </p>
      <p>
        Remember, this eating structure is flexible. The number of meals you eat
        during this time period is up to you, so whether it’s two or five meals
        doesn’t matter. Your only focus is eating by the clock. Plus, you can
        shift your eating window. So if one day you want to start eating at noon
        and the next you want to eat at three p.m., it’s fine—as long as you
        still end up fasting for sixteen hours and eating for eight.
      </p>
      <h4>Training and Nutrient Timing</h4>
      <p>
        You’ll be eating your carbohydrates later in the day in order to
        maximize the effects of your naturally higher insulin sensitivity. On
        non-workout days, eat these carbs three to four hours before you go to
        bed. (If you go to bed at ten p.m., don’t eat carbs before six p.m.)
        Your meals prior to this will consist of protein and fat.
      </p>
      <p>
        On workout days, it’s best to have carbs after your workout; for this
        reason, we recommend training a bit later in the day. Your first meal of
        the day should consist of protein and fat and would ideally take place
        about three to four hours before your workout. Your next meal would be
        immediately after your workout, and all the allotted carbs for the day
        should be eaten then.
      </p>
    </div>
  );
};

export default Info;



// WEBPACK FOOTER //
// ./src/containers/Info/Info.js